var _circle, _path, _path2, _line, _line2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyIncidentNotificationRuleSteps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 103,
    viewBox: "0 0 110 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5449,
    cy: 16.352,
    r: 5.04556,
    transform: "rotate(-20.9144 40.5449 16.352)",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.4785 42.1661C84.3526 28.7528 69.3235 22.0345 55.9102 27.1604C42.4969 32.2863 35.7786 47.3153 40.9045 60.7287L46.4711 75.2951C47.6446 78.366 46.8996 81.84 44.57 84.1596L41.4218 87.2943L44.9915 96.6354L109.445 72.0043L105.876 62.6632L102.12 62.2916C98.9668 61.9796 96.2604 59.9128 95.1292 56.9528L89.4785 42.1661Z",
    fill: "#DEDBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9045 59.7287L35.4711 74.2951C36.6446 77.366 35.8996 80.84 33.57 83.1596L30.4218 86.2943L33.9915 95.6354L98.5 70.5L94.8757 61.6632L91.1202 61.2916C87.9668 60.9796 85.2604 58.9128 84.1292 55.9528L78.4785 41.1661C73.3526 27.7528 58.3235 21.0345 44.9102 26.1604C31.4969 31.2863 24.7786 46.3153 29.9045 59.7287Z",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.6235,
    y1: 64.0423,
    x2: 79.3292,
    y2: 46.1937,
    stroke: "#5A4BF8",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 35.1223,
    y1: 70.5811,
    x2: 81.828,
    y2: 52.7325,
    stroke: "#5A4BF8",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.301 85.0581C63.2725 90.217 60.6886 95.9974 55.5296 97.9689C50.3706 99.9404 44.5902 97.3565 42.6187 92.1975",
    stroke: "#5A4BF8",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.973 8.05368C80.9134 8.05368 82.4865 6.47466 82.4865 4.52684C82.4865 2.57902 80.9134 1 78.973 1C77.0325 1 75.4595 2.57902 75.4595 4.52684C75.4595 6.47466 77.0325 8.05368 78.973 8.05368Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59459 35.4872C5.02755 35.4872 6.18919 34.3211 6.18919 32.8827C6.18919 31.4443 5.02755 30.2783 3.59459 30.2783C2.16164 30.2783 1 31.4443 1 32.8827C1 34.3211 2.16164 35.4872 3.59459 35.4872Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1351 20.4411L101.378 25.7042",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1351 25.7042L101.378 20.4411",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1081 90.175L16.2432 99.2363C16.2432 99.4533 16.4054 99.5619 16.6216 99.5076L24.8919 95.7095C25.054 95.6009 25.1081 95.3839 24.9459 95.2754L17.5405 89.958C17.3784 89.8495 17.1621 89.958 17.1081 90.175Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.973 47.0741H96.8918C96.6756 47.0741 96.5675 47.2911 96.6756 47.4539L101.216 55.3757C101.324 55.5385 101.595 55.5385 101.649 55.3757L106.189 47.4539C106.297 47.2911 106.189 47.0741 105.973 47.0741Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIncidentNotificationRuleSteps);
export default __webpack_public_path__ + "static/media/EmptyIncidentNotificationRuleSteps.16567e95647b21e104b3baaa1e8cd055.svg";
export { ForwardRef as ReactComponent };